import GuestsTotalPrice from 'components/common/MarchPromo/components/GuestsTotalPrice/GuestsTotalPrice'
import { useGuestsCart } from 'components/common/MarchPromo/utils/useGuestsCart'
import Box from 'components/shared/Box'
import Button from 'components/shared/Button'
import Info from 'components/shared/Info'
import { CancelButton } from 'components/shared/Promotions/components/MarchPromoInfo/components/VoucherForm/styles'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

export const VoucherFormFooter = ({
    onCancel,
    onSuccess,
}: {
    onCancel: () => void
    onSuccess: () => void
}) => {
    const {
        addItemsToCart,
        isSubmitLoading,
        isSubmitSuccess,
        isSubmitError,
        isEditLoading,
        isEditError,
    } = useGuestsCart()

    useEffect(() => {
        isSubmitSuccess && onSuccess()
    }, [isSubmitSuccess])

    return (
        <Box direction="column" gap={[16, 24]} isFullWidth>
            {(isSubmitError || isEditError) && (
                <Info color="error" variantType="warning">
                    <FormattedMessage
                        id="global.error.generic_technical_issue"
                        defaultMessage="Napotkaliśmy problem techniczny. Odśwież stronę lub spróbuj ponownie później."
                    />
                </Info>
            )}
            <Box
                direction={['column', 'row']}
                justify="space-between"
                align={['flex-end', 'center']}
                gap={12}
                isFullWidth
            >
                <GuestsTotalPrice />
                <Box direction="row" gap={24} align="center">
                    <CancelButton
                        onClick={onCancel}
                        disabled={isSubmitLoading || isEditLoading}
                    >
                        <FormattedMessage
                            id="global.btn.cancel"
                            defaultMessage="Anuluj"
                        />
                    </CancelButton>
                    <Button
                        variant="secondary"
                        width="initial"
                        onClick={() => {
                            addItemsToCart()
                        }}
                        isLoading={isSubmitLoading || isEditLoading}
                    >
                        <FormattedMessage
                            id="promo.march.add_btn"
                            defaultMessage="Dodaj"
                        />
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}
